<template>
  <div class="flex flex-col">
    <div class="lg:flex">
      <div class="w-96 mb-4 ">
        <div class="flex-shrink-0 md:w-96 xl:w-96 lg:w-96 border border-gray-200">
          <div class='text-xs leading-3 text-gray-900 bg-gray-50 border-b' v-for="option in options" v-bind:key="option.to">
            <div >
              <button @click="nav = option.to" :class="nav == option.to ? 'bg-gray-300' : ''" class="active flex items-center relative inline-flex items-center px-4 bg-white text-sm font-medium text-gray-700 w-full focus:outline-none">
                <div class="pl-0 pr-1 py-3"> {{ $t(`message.${option.title}`) }} </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="ml-4 -mr-4 w-full grid grid-cols-1 gap-4 grid-flow-col-dense">
        <div class="space-y-6 col-span-1">
          <users
            v-if="nav == 'users'"
          />
          <detentions
            v-else-if="nav == 'detentions'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from '@/views/configuration/Users'
import Detentions from '@/views/configuration/Detentions'

export default {
  name: 'configuration',
  components: { Users, Detentions },
  created(){
    this.getOptions()
  },
  data() {
    return {
      nav: 'users',
      options: []
    }
  },
  methods: {
    async getOptions(){
      const { data } = await this.$http.get(`/configuration`);
      this.options = data;
    }
  }
}
</script>